import * as React from "react";
import * as SwitchPrimitives from "@radix-ui/react-switch";

import { cn } from "@/lib/utils";

const CustomSwitch = React.forwardRef<
  React.ElementRef<typeof SwitchPrimitives.Root>,
  React.ComponentPropsWithoutRef<typeof SwitchPrimitives.Root>
>(({ className, ...props }, ref) => (
  <SwitchPrimitives.Root
    className={cn(
      "peer inline-flex h-6 w-12 shrink-0 cursor-pointer items-center rounded-full border border-transparent transition-colors  border-solid border-black focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gray-950 focus-visible:ring-offset-2 focus-visible:ring-offset-white disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-white data-[state=unchecked]:bg-white",
      className,
    )}
    {...props}
    ref={ref}
  >
    <SwitchPrimitives.Thumb
      className={cn(
        "pointer-events-none block h-4 w-4 rounded-full shadow-lg ring-0 transition-transform",
        "data-[state=checked]:translate-x-7 data-[state=unchecked]:translate-x-[3px]",
        // Universal for our site
        "bg-[#1D1D1D]",
        //EXclusively for Possession tab in About scction.
        "[.possession-toggle.green_&]:bg-[#7AC51C]", //Available
        "[.possession-toggle.yellow_&]:bg-[#F98D1C]", //On Hold
        "[.possession-toggle.red_&]:bg-[#FF2727]", //Sold
        "[.possession-toggle.blue_&]:bg-[#007BFF]", //External
      )}
    />
  </SwitchPrimitives.Root>
));
CustomSwitch.displayName = SwitchPrimitives.Root.displayName;

export { CustomSwitch };
